import React from 'react';

function SignUpFrom({ inputArea, acceptArea, handleArea, onSubmit }) {
    return (
        <form className="login_inputbox" onSubmit={onSubmit}>
            <fieldset className="signup-input">{inputArea}</fieldset>
            <fieldset className="signup-accept">{acceptArea}</fieldset>
            <fieldset className="signup-handler">{handleArea}</fieldset>
        </form>
    );
}

export default SignUpFrom;
